// Plain-words summary of the auto-sorting check returned by /api/matching-bench (numbers only).
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const n = (v) => Number(v || 0).toLocaleString('en-US');
// Rounds down so anything short of perfect never shows as 100% right.
const pct = (b) => (b && b.count > 0 ? `${Math.floor((b.correct * 100) / b.count)}% right` : 'none to check');
const monthYear = (d) => (d && d.month >= 1 && d.month <= 12 ? `${MONTHS[d.month - 1]} ${d.year}` : '');

// Returns { intro, lines: [string], note }, or null when there is nothing to report.
export function describeSortingCheck(data) {
  if (!data || !data.rowsConsidered) return null;
  const from = monthYear(data.range && data.range.from);
  const to = monthYear(data.range && data.range.to);
  const when = from && to ? ` from ${from} to ${to}` : '';
  return {
    intro: `We replayed your ${n(data.rowsConsidered)} sorted expenses${when}, guessing each one using only what came before it.`,
    lines: [
      `Would have been sorted automatically: ${n(data.auto && data.auto.count)}, ${pct(data.auto)}.`,
      `Would have been suggested: ${n(data.suggested && data.suggested.count)}, ${pct(data.suggested)}.`,
      `Low-confidence guess: ${n(data.low && data.low.count)}, ${pct(data.low)}.`,
      `Canopy had no guess: ${n(data.none && data.none.count)}. The first expense from each vendor has nothing to learn from yet, so it always lands here.`,
    ],
    note: 'Right means the guess went to the same job you chose.',
  };
}
